/* generated by pull.js */
const manifest = {
  editorOnly: true,
  dynamicDisable: true,
  name: 'Show FPS',
  description: 'Display the current FPS (frames per second) above the stage.',
  tags: ['new', 'recommended'],
  credits: [
    {
      name: 'KOSHINO',
      link: 'https://github.com/KOSHINOawa'
    }
  ],
  enabledByDefault: true,
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  userstyles: [
    {
      url: 'style.css'
    }
  ]
};
export default manifest;
